/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description ViewClaimWorklistDetails
 */
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';

import { WorkListTypeBadge } from 'components/eligibility/response/StatusBadge';
import TypographyWithTooltip from 'components/common/TypographyWithTooltip';
import { getClaimWorkListResponsePath } from 'utils/router';

/**
 * ViewClaimWorklistDetails
 */
const ViewClaimWorklistDetails: React.FC<{
	worklist: ClaimWorkLists.IWorkListResponse | ClaimWorkLists.IEntityWorklistResponse;
}> = ({ worklist }) => {
	return (
		<Row align='middle' wrap={false} gutter={4} className='w-full'>
			<Col flex='unset'>
				<TypographyWithTooltip
					showArrow
					content={<Link to={getClaimWorkListResponsePath({ id: worklist?.id })}>{worklist?.name}</Link>}
				/>
			</Col>
			<Col flex='84px'>
				<WorkListTypeBadge type={worklist?.type} />
			</Col>
		</Row>
	);
};

export default ViewClaimWorklistDetails;
